/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import React, { useState } from 'react';
import { Box, CircularProgress } from '@mui/material';

import { SelectedLocationCardProps } from '../AllJobs.Model';
import Button, { ButtonType } from '../../../../../Shared/Components/Common/Buttons/Button';

import { Loader } from '../../../../Jobs/Components/JobView/JobsView.styles';
import {
  AddressText,
  CurrentLocation,
  CurrentLocationText,
} from '../../../../Facility/Components/AddFacility/AddFacility.Style';
import theme from '../../../../../Shared/Themes/theme';
import { Icons } from '../../../../../Shared/Constants/Icons';
import { useTranslation } from 'react-i18next';
import { HeaderContainer, TextContainer } from './ModifyGeoFence.Style';

const SelectedLocationCard: React.FC<SelectedLocationCardProps> = ({
  currentAddress,
  loading,
  latitude,
  longitude,
  isError,
  handleSubmit,
}): JSX.Element => {
  const [openLatLng, setOpenLatLng] = useState(false);

  const { t } = useTranslation(['jobManagement']);

  const handleToggleLatLng = () => {
    setOpenLatLng(!openLatLng);
  };
  const handleSave = () => {
    setOpenLatLng(true);
  };

  const handleConfirmButton = () => {
    if (latitude && longitude) {
      handleSubmit(latitude, longitude);
    }
  };

  return (
    <>
      <CurrentLocation sx={{ padding: '1.5rem', width: '22.5rem' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          {loading ? (
            <Loader sx={{ width: '100%' }}>
              <CircularProgress size={30} sx={{ color: theme.palette.primary.dark }} />
            </Loader>
          ) : (
            <>
              <CurrentLocationText sx={{ marginBottom: '0.5rem' }}>
                {t('jobManagement:selectedLocation')}
              </CurrentLocationText>
              <img
                src={openLatLng ? Icons.DropdownDownIcon : Icons.DropdownUpIcon}
                style={{ width: '1.5rem', height: '1.5rem', cursor: 'pointer' }}
                onClick={handleToggleLatLng}
              />
            </>
          )}
        </Box>
        {!loading ? (
          <>
            <AddressText sx={{ marginBottom: '1.5rem' }}>{currentAddress} </AddressText>
            {openLatLng ? (
              <Box sx={{ display: 'flex', flexDirection: 'row', gap: '3rem' }}>
                <Box sx={{ marginBottom: '2rem' }}>
                  <HeaderContainer>{`${t('jobManagement:latitude')}:`}</HeaderContainer>
                  <TextContainer>{latitude}</TextContainer>
                </Box>
                <Box sx={{ marginBottom: '2rem' }}>
                  <HeaderContainer>{`${t('jobManagement:longitude')}:`}</HeaderContainer>
                  <TextContainer>{longitude}</TextContainer>
                </Box>
              </Box>
            ) : null}

            {openLatLng ? (
              <Button
                type={ButtonType.Primary}
                label={t('dashboard:confirm')}
                width="100%"
                onClick={handleConfirmButton}
                isLoading={false}
                disabled={isError}
              />
            ) : (
              <Button
                type={ButtonType.Primary}
                label={t('jobManagement:saveThisLocation')}
                width="100%"
                onClick={handleSave}
                isLoading={false}
                disabled={isError}
              />
            )}
          </>
        ) : null}
      </CurrentLocation>
    </>
  );
};

export default SelectedLocationCard;
